<script setup lang="ts">
import { getLegalDocument, type LegalDocument } from '@/api/website'
import { onMounted, ref } from 'vue'

const props = defineProps<{
  slug: string
}>()

const legalDocument = ref<LegalDocument>()
const loading = ref(true)
const unavailable = ref(false)

function formatUpdatedAt(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
}

onMounted(async () => {
  try {
    legalDocument.value = await getLegalDocument(props.slug)
    window.document.title = legalDocument.value.title
  } catch {
    unavailable.value = true
    window.document.title = '协议或声明'
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="agreement-page">
    <main class="container agreement-main">
      <article class="agreement-document">
        <div v-if="loading" class="agreement-state">正在读取内容…</div>
        <div v-else-if="unavailable || !legalDocument" class="agreement-state">
          <h1>协议或声明尚未发布</h1>
          <p>当前内容暂不可用，请稍后再试。</p>
        </div>
        <template v-else>
          <header>
            <h1>{{ legalDocument.title }}</h1>
            <p>更新时间：{{ formatUpdatedAt(legalDocument.updatedAt) }}</p>
          </header>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="agreement-content" v-html="legalDocument.content"></div>
        </template>
      </article>
    </main>
  </div>
</template>
